<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import AutorizacaoList from "../autorizacao/AutorizacaoList";
import Veiculo from "./Veiculo";

export default {
  components: {
    //AutorizacaoList,
    //Veiculo
  },
  data() {
    return {
      veiculo: null,
      veiculoTransportadoraId: null
    };
  },
  methods: {
    loadVeiculo() {
      // load veiculos
    },
    initData() {
      const { veiculoId } = this.$route.params;
      this.veiculoTransportadoraId = Number(veiculoId);
    }
  },
  mounted() {
    this.initData();
  }
};
</script>

